import React from 'react';

export default function ErrorRetry({
  message = 'حدث خطأ أثناء تحميل البيانات',
  onRetry,
  retryLabel = 'إعادة المحاولة',
  style = {},
}) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 'var(--sp-4xl) var(--sp-xl)',
      textAlign: 'center',
      ...style,
    }}>
      <div style={{
        width: '56px', height: '56px', borderRadius: '50%',
        backgroundColor: '#ffebee', display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 'var(--sp-lg)', fontSize: '28px',
      }}>
        ⚠️
      </div>
      <p style={{
        fontSize: 'var(--font-size-base)', color: 'var(--color-text)',
        margin: '0 0 var(--sp-lg) 0', maxWidth: '360px',
      }}>
        {message}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: '10px 24px', borderRadius: 'var(--radius-sm)', border: 'none',
            backgroundColor: 'var(--color-primary)', color: 'white',
            fontSize: 'var(--font-size-base)', fontWeight: '600', cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: '8px',
          }}
        >
          <span>🔄</span>
          <span>{retryLabel}</span>
        </button>
      )}
    </div>
  );
}
